// import React, { useState } from 'react';
// import fileIcon from './file-icon.png'; // Ensure this path is correct
// import uploadIcon from '../icons/upload-icon.png';
// import './UploadSection.css';
// import { API_ENDPOINTS } from '../config';

// function UploadSection({ title, formats, onFileUpload, disabled, patientId, claimId }) {
//   const [files, setFiles] = useState([]);
//   const [progress, setProgress] = useState({});
//   const [uploading, setUploading] = useState({});
//   const [isDragging, setIsDragging] = useState(false);

//   const handleFileChange = async (event) => {
//     const selectedFiles = Array.from(event.target.files);
//     setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);

//     selectedFiles.forEach((file) => onFileUpload(title, [file]));
//   };

//   const handleDragOver = (event) => {
//     event.preventDefault();
//     setIsDragging(true);
//   };

//   const handleDragLeave = () => {
//     setIsDragging(false);
//   };

//   const handleDrop = (event) => {
//     event.preventDefault();
//     const selectedFiles = Array.from(event.dataTransfer.files);
//     setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);

//     selectedFiles.forEach((file) => onFileUpload(title, [file]));
//     setIsDragging(false);
//   };

//   // const handleFileRemove = async (fileToRemove) => {
//   //   if (!patientId || !claimId) {
//   //     alert('Cannot delete the file because patient ID or claim ID is missing.');
//   //     return;
//   //   }
//   //   const formattedTitle = title.replace(/ /g, '_').toLowerCase();
//   //   const filePath = `${patientId}/${claimId}/${formattedTitle}/${fileToRemove.name}`;
  
//   //   // Remove file from UI
//   //   setFiles((prevFiles) => prevFiles.filter((file) => file !== fileToRemove));
  
//   //   // Send request to delete the file from S3
//   //   try {
//   //     const response = await fetch(`${API_ENDPOINTS.PYTHON_SERVICE}/delete-file`, {
//   //       method: 'DELETE',
//   //       headers: { 'Content-Type': 'application/json' },
//   //       body: JSON.stringify({ filePath }), // Ensure proper JSON format
//   //     });
  
//   //     if (!response.ok) {
//   //       const errorMessage = await response.text();
//   //       console.error('File deletion failed:', errorMessage);
//   //       alert('Failed to delete the file.');
//   //     } else {
//   //       console.log('File deleted successfully');
//   //     }
//   //   } catch (error) {
//   //     console.error('File deletion error:', error);
//   //     alert('An error occurred while deleting the file.');
//   //   }
//   // };
//   const handleFileRemove = async (fileToRemove) => {

//     console.log('Removing file:', fileToRemove.name);
//     console.log('Patient ID:', patientId, 'Claim ID:', claimId);
//     if (!patientId || !claimId) {
//       alert(`Cannot delete the file because ${!patientId ? 'Patient ID' : 'Claim ID'} is missing.`);
//       return;
//     }
    
//     const formattedTitle = title.replace(/ /g, '_').toLowerCase();
//     const filePath = `${patientId}/${claimId}/${formattedTitle}/${fileToRemove.name}`;
    
//     setFiles((prevFiles) => prevFiles.filter((file) => file !== fileToRemove));
    
//     try {
//       const response = await fetch(`${API_ENDPOINTS.PYTHON_SERVICE}/delete-file`, {
//         method: 'DELETE',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ filePath }),
//       });
  
//       if (!response.ok) {
//         const errorMessage = await response.text();
//         console.error('File deletion failed:', errorMessage);
//         alert('Failed to delete the file.');
//       } else {
//         console.log('File deleted successfully');
//       }
//     } catch (error) {
//       console.error('File deletion error:', error);
//       alert('An error occurred while deleting the file.');
//     }
//   };
  

//   return (
//     <div className={`upload-section ${disabled ? 'disabled' : ''}`}>
//       <h3>{title}</h3>
//       <div
//         className={`upload-box ${Object.values(uploading).some((isUploading) => isUploading) ? 'uploading' : ''} ${
//           isDragging ? 'dragging' : ''
//         }`}
//         onDragOver={handleDragOver}
//         onDragLeave={handleDragLeave}
//         onDrop={handleDrop}
//       >
//         <label className="custom-file-label">
//           <input
//             type="file"
//             accept={formats}
//             multiple
//             onChange={handleFileChange}
//             disabled={disabled}
//             className="custom-file-input"
//           />
//           <div className="upload-text">
//             <img src={uploadIcon} alt="Upload Icon" className="upload-icon" />
//             <p>
//               Drag and drop here<br />or <span className="browse-link">browse</span>
//             </p>
//           </div>
//         </label>
//         <div className="file-info">
//           {files.length > 0 && (
//             <div className="file-preview">
//               {files.map((file, index) => (
//                 <div key={index} className="file-item">
//                   <div className="file-details">
//                     <img src={fileIcon} alt="File Icon" className="file-icon" />
//                     <span className="file-name">{file.name}</span>
//                   </div>
//                   <button className="cancel-button" onClick={() => handleFileRemove(file)}>
//                     X
//                   </button>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//       <p>Supported formats: {formats}</p>
//     </div>
//   );
// }

// export default UploadSection;






// lock-icon  part

import React, { useState } from 'react';
import fileIcon from './file-icon.png'; // adjust path as needed
import uploadIcon from '../icons/upload-icon.png';
import './UploadSection.css';
import { API_ENDPOINTS } from '../config';

function UploadSection({
  title,
  formats,
  onFileUpload,
  disabled,
  patientId,
  claimId,
  lockIcon // <-- Accept the lockIcon as a prop
}) {
  const [files, setFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);

  const handleFileChange = async (event) => {
    const selectedFiles = Array.from(event.target.files);
    setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
    selectedFiles.forEach((file) => onFileUpload(title, [file]));
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const selectedFiles = Array.from(event.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
    selectedFiles.forEach((file) => onFileUpload(title, [file]));
    setIsDragging(false);
  };

  const handleFileRemove = async (fileToRemove) => {
    // If patientId or claimId is missing, do not attempt deletion
    if (!patientId || !claimId) {
      alert(
        `Cannot delete the file because ${
          !patientId ? 'Patient ID' : 'Claim ID'
        } is missing.`
      );
      return;
    }

    const formattedTitle = title.replace(/ /g, '_').toLowerCase();
    const filePath = `${patientId}/${claimId}/${formattedTitle}/${fileToRemove.name}`;

    // Remove file from local state
    setFiles((prevFiles) => prevFiles.filter((file) => file !== fileToRemove));

    // Make a request to backend to delete from S3
    try {
      const response = await fetch(`${API_ENDPOINTS.PYTHON_SERVICE}/delete-file`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ filePath })
      });
      if (!response.ok) {
        const errorMessage = await response.text();
        console.error('File deletion failed:', errorMessage);
        alert('Failed to delete the file.');
      } else {
        console.log('File deleted successfully');
      }
    } catch (error) {
      console.error('File deletion error:', error);
      alert('An error occurred while deleting the file.');
    }
  };

  // If disabled, just show a "locked" section
  if (disabled) {
    return (
      <div className="upload-section locked-section">
        <h3>{title}</h3>
        <div className="locked-box">
          {lockIcon && <img src={lockIcon} alt="Locked icon" className="lock-icon" />}
          <p className="locked-text">Locked</p>
        </div>
        <p>Supported formats: {formats}</p>
      </div>
    );
  }

  // Otherwise, show the normal upload UI
  return (
    <div className={`upload-section ${isDragging ? 'dragging' : ''}`}>
      <h3>{title}</h3>
      <div
        className="upload-box"
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <label className="custom-file-label">
          <input
            type="file"
            accept={formats}
            multiple
            onChange={handleFileChange}
            className="custom-file-input"
          />
          <div className="upload-text">
            <img src={uploadIcon} alt="Upload Icon" className="upload-icon" />
            <p>
              Drag and drop here<br />
              or <span className="browse-link">browse</span>
            </p>
          </div>
        </label>

        {/* Preview of uploaded files */}
        {files.length > 0 && (
          <div className="file-preview">
            {files.map((file, index) => (
              <div key={index} className="file-item">
                <div className="file-details">
                  <img src={fileIcon} alt="File Icon" className="file-icon" />
                  <span className="file-name">{file.name}</span>
                </div>
                <button className="cancel-button" onClick={() => handleFileRemove(file)}>
                  X
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
      <p>Supported formats: {formats}</p>
    </div>
  );
}

export default UploadSection;
